<template>
  <div class="publishers">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" color="#fff">
        <use xlink:href="#icon-Publishers-"></use>
      </svg>
    </breadcrumbs>
    <a-tour :arrow="true" :open="open" :steps="steps" @close="handleOpen(false)" placement="bottom">
    
    </a-tour>
    <div class="content">
   
      <publisherTable :dataSource="dataSource" :disabled="true" />
      <!-- <div class="table-body" ref="tableBodyRef">
        <div class="content-wrapper">
          <div class="tabs">
            <artmisads-segmented-tabs v-model="activeTab" :items="programConfig" />
          </div>
           
          <PublisherAssociateTable
            :publisherId="publisherId"
            :creatorName="creatorName"
            :associateEnabled="associateEnabled"
            ref="publisherAssociateTable"
            @data-loaded="onDataLoaded"
          />
        </div>
        <div class="left" v-if="open" ref="leftRef" :style="{ height: leftHeight + 'px' }" @click.stop @mousedown.stop @mouseup.stop @mousemove.stop @keydown.stop @keyup.stop @keypress.stop @focus.stop @blur.stop @change.stop @input.stop @submit.stop @reset.stop @select.stop @selectstart.stop @copy.stop @cut.stop @paste.stop @drag.stop @dragstart.stop @dragend.stop @dragover.stop @dragenter.stop @dragleave.stop @drop.stop @contextmenu.stop @wheel.stop @touchstart.stop @touchmove.stop @touchend.stop @touchcancel.stop @mouseenter.stop @mouseleave.stop @mouseover.stop @mouseout.stop @scroll.stop @wheel.prevent @touchmove.prevent>

        </div>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, nextTick, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import breadcrumbs from '../breadcrumbs.vue'
import { useRoute } from 'vue-router'
import publisherTable from './components/publisherTable.vue'
import PublisherAssociateTable from '~/components/PublisherAssociateTable.vue'
import { useUserInfoStore } from '~/storeData/index';
import jwt from 'jsonwebtoken';
import { adminApi } from '~/server/index';
import { publishersApi } from '@/server'

const { t } = useI18n()
const store = useUserInfoStore();
const open = ref(false)
const leftRef = ref(null)
const publisherAssociateTable = ref(null)
const steps = computed(() => [
  {
    title: t('seller.publishersPage.tourTitle'),
    target: () => leftRef.value,
    description: t('seller.publishersPage.tourDetailStepDesc'),
    placement: 'right',
  },
  {
    title: t('seller.publishersPage.tourTitle'),
    description: t('seller.publishersPage.tourDetailStepDesc'),
    placement: 'right',
    target: () => {
      if (publisherAssociateTable.value) {
        const refs = publisherAssociateTable.value.getAllActionButtonsRefs()
        if (refs && refs.length > 0) {
          return refs[0]
        }
      }
      return publisherAssociateTable.value
    },
  },

])

const handleOpen = async(value) => {
  open.value = value
  
  // 当漫游导航打开时，阻止页面滚动
  if (value) {
    // 添加CSS类来阻止滚动
    document.body.classList.add('tour-active')
    
    // 阻止页面滚动
    const preventScroll = (e) => {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      return false
    }
    
    // 添加滚动事件监听器到document
    const scrollEvents = ['wheel', 'scroll', 'touchmove', 'touchstart', 'touchend', 'touchcancel']
    scrollEvents.forEach(eventType => {
      document.addEventListener(eventType, preventScroll, { passive: false, capture: true })
    })
    
    // 存储事件监听器引用，以便后续移除
    window.tourScrollListeners = scrollEvents.map(eventType => {
      return { eventType, handler: preventScroll }
    })
  } else {
    // 当漫游导航关闭时，移除事件监听器
    document.body.classList.remove('tour-active')
    
    if (window.tourScrollListeners) {
      window.tourScrollListeners.forEach(({ eventType, handler }) => {
        document.removeEventListener(eventType, handler, { capture: true })
      })
      window.tourScrollListeners = null
    }
    const res = await adminApi.associatePublisherDetailCompleted()
    const { success, error, data } = res;
    if(success){
      const userToken = data.token;
      const userInfo = jwt.decode(userToken);
      const menus = store.userInfo.menus;
      store.setUserInfo(userInfo,userToken,menus);
    }
  }
}
const programConfig = computed(() => [
  { key: '0', label: t('seller.publishersPage.tabAssociate'), disabled: false }
])
const route = useRoute()
const activeTab = ref('0')
const creatorName=ref('')
const dataSource = ref([])
const publisherId = route.params.id

const associateEnabled = ref(false)
const breadcrumbsData = computed(() => ({
  title: t('seller.menu.publishers'),
  hasTitleIcon: true,
  color: '#80C026',
  links: [
    {
      name: t('seller.common.home'),
      path: '/seller/dashboard'
    },
    {
      name: t('seller.menu.publishers'),
      path: '/seller/publishers'
    }
  ]
}))

const leftHeight = ref(0)
const tableBodyRef = ref(null)

function updateLeftHeight() {
  // 以 table-body 可视高度为基准（减去内边距或固定偏移视需求调整）
  const tableBodyEl = tableBodyRef.value || document.querySelector('.table-body')
 
  
  if (tableBodyEl) {
    const rect = tableBodyEl.getBoundingClientRect()
   
    // 使用内容高度：视窗内可用高度
    const available = Math.max(0, Math.floor(rect.height))
  

    leftHeight.value = available
   
  } else {
    

    // 兜底：使用窗口高度的 60%
    leftHeight.value = Math.floor(window.innerHeight * 0.6)
   
  }
 
}

function setupResizeObserver() {
  const tableBodyEl = tableBodyRef.value || document.querySelector('.table-body')
  if (!tableBodyEl) return
  // 使用 ResizeObserver 监听容器尺寸变化
  if (window.ResizeObserver) {
    const ro = new ResizeObserver(() => updateLeftHeight())
    ro.observe(tableBodyEl)
    // 在实例上挂一份，卸载时释放
    window.__leftResizeObserver = ro
  } else {
    // 退化到 window resize
    window.addEventListener('resize', updateLeftHeight)
    window.__leftWindowResizeFallback = true
  }
}

// 子组件数据加载完成后的回调
function onDataLoaded(data) {

  if(store.userInfo.associatePublisherDetailCompleted === 'N'&& associateEnabled.value&&data.length > 0){
  nextTick(() => {
    updateLeftHeight() // 初始化高度
    setupResizeObserver() // 设置监听器
    // 延迟启动轮询检查，确保子组件已经渲染
   
    setTimeout(() => {
      // 轮询检查子组件数据是否已加载
      let checkCount = 0
      const maxChecks = 100 // 最多检查100次（10秒）
      const checkInterval = setInterval(() => {
        if (checkAndUpdateHeight() || checkCount >= maxChecks) {
          clearInterval(checkInterval)
       
        }
        checkCount++
      }, 100)
      
      handleOpen(true)
    }, 200)

  })
}
  // 延迟执行，确保 DOM 完全更新
  setTimeout(() => {
    updateLeftHeight()
  }, 300)
}

// 检查子组件数据是否已加载并重新计算高度
function checkAndUpdateHeight() {
  if (publisherAssociateTable.value && publisherAssociateTable.value.data && publisherAssociateTable.value.data.length > 0) {
  
    updateLeftHeight()
    return true
  }
  
  // 额外检查：直接检查表格是否有实际的行
  const tableRows = document.querySelectorAll('.ant-table-tbody tr')
  if (tableRows.length > 0) {
  
    updateLeftHeight()
    return true
  }
  
  return false
}

onMounted(() => {
 
  
  if(publisherId){
    publishersApi.getPublisherDetailByPublisherId({id:publisherId}).then((res) => {

      dataSource.value = [res.data.publisherVO]
      associateEnabled.value = res.data.associateEnabled
      creatorName.value = dataSource.value[0]?.creatorName
    })
  }else{
if(sessionStorage.getItem('publisherDetail') && JSON.parse(sessionStorage.getItem('publisherDetail'))){
    dataSource.value = [JSON.parse(sessionStorage.getItem('publisherDetail'))]
  associateEnabled.value = dataSource.value[0]?.associateEnabled
    creatorName.value = dataSource.value[0]?.creatorName
  }
  }

})

// 组件卸载时清理事件监听器
onUnmounted(() => {
  if (window.tourScrollListeners) {
    window.tourScrollListeners.forEach(({ eventType, handler }) => {
      document.removeEventListener(eventType, handler, { capture: true })
    })
    window.tourScrollListeners = null
  }
  if (window.__leftResizeObserver) {
    window.__leftResizeObserver.disconnect()
    window.__leftResizeObserver = null
  }
  if (window.__leftWindowResizeFallback) {
    window.removeEventListener('resize', updateLeftHeight)
    window.__leftWindowResizeFallback = null
  }
  sessionStorage.clear('publisherDetail')
})
</script>
<style>
.ant-tour-arrow::before {
  clip-path: path('M 0 8 A 4 4 0 0 0 2.82842712474619 6.82842712474619 L 6.585786437626905 3.0710678118654755 A 2 2 0 0 1 9.414213562373096 3.0710678118654755 L 13.17157287525381 6.82842712474619 A 4 4 0 0 0 16 8 Z') !important;
}

/* 当漫游导航激活时，阻止页面滚动 */
body.tour-active {
  overflow: hidden !important;
  height: 100vh !important;
  touch-action: none !important;
  -webkit-overflow-scrolling: touch !important;
  position: fixed !important;
  width: 100% !important;
}

</style>
<style scoped lang="less">
.publishers {
  padding: 16px;
  padding-top: unset;
}
.tabs{
 
  .artmisads-segmented-tabs{
    margin: 0;
  }
}
.table-body {
  padding: 16px;
  padding-bottom: 0;
  position: relative;
  gap: 20px;
  margin-top: 30px;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0 1px 0 0 #0f06290d, 0 2px 8px 0 #00000014;
  .left{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    z-index: 1;
    background-color: transparent;
}
}

</style>